import React from 'react';
import { generatePageParagraphs } from 'cms/parsers';

const BasicPage = ({ pageManifest }) => {

  const { field_paragraph } = pageManifest.relationships;
  const Children = generatePageParagraphs(field_paragraph.data);
  
  return (
    <> 
      {Children}
    </>
  );
};

export default BasicPage;
